import type { ListItemProps } from "@/components/ListItem/ListItem";
import SectionHeading from "@/components/SectionHeading";
import DetailsCard from "@/components/DetailsCard";
import { toFormat } from "@/lib/dateHelpers";
import type { MembershipApplicationDetail } from "../queries";

interface Props {
  application: MembershipApplicationDetail;
}

const AMATEUR_EVENT_FORFEITURE_TEXT = "Participation forfeits work experience credits earned prior to the event";

const AMATEUR_EVENT_DATE_FORMAT = "LLL dd, yyyy";

export function formatAmateurEventHeadline(
  lastAmateurEvent: boolean | null | undefined,
  lastAmateurEventDate: string | null | undefined
): string {
  const response = lastAmateurEvent === true ? "Yes" : "No";
  if (lastAmateurEvent !== true) return response;

  const formattedDate = lastAmateurEventDate ? toFormat(lastAmateurEventDate, AMATEUR_EVENT_DATE_FORMAT) : null;
  return formattedDate ? `${response} (${formattedDate})` : response;
}

function acknowledgementOptions(application: MembershipApplicationDetail): ListItemProps[] {
  const options: ListItemProps[] = [
    {
      iconName: "verified_user",
      overline: "Beneficiary Attestation",
      headline: application.beneficiaryDesignationAttested ? "Acknowledged" : "Not Acknowledged"
    },
    {
      iconName: "fact_check",
      overline: "Terms of Agreement",
      headline: application.agreedToTerms ? "Acknowledged" : "Not Acknowledged"
    },
    {
      iconName: "gavel",
      overline: "Criminal History",
      headline: application.hasCriminalHistory ? "Yes" : "No",
      supportingText: application.hasCriminalHistory ? "Convicted of a misdemeanor or felony" : null
    }
  ];

  if (application.applicationType === "associate") {
    options.push({
      iconName: "event_available",
      overline: "Amateur Event Attendance",
      headline: formatAmateurEventHeadline(application.lastAmateurEvent, application.lastAmateurEventDate),
      supportingText: AMATEUR_EVENT_FORFEITURE_TEXT
    });
  }

  return options;
}

export default function AcknowledgementsSection({ application }: Props) {
  return (
    <>
      <SectionHeading heading="Application Acknowledgements" body="View eligibility details of the application" />
      <div className="w-full min-w-[364px] max-w-[696px]">
        <DetailsCard heading="" options={acknowledgementOptions(application)} />
      </div>
    </>
  );
}
